import { useState, useEffect } from "react";
import { useApp, api } from "../context";
import { Shell, Btn, EmptyState } from "../components";

const CATEGORIES = ["All","Romance","Thriller","Drama","Fantasy","Educational","Solo","Couples","Group","Fetish","BDSM","Amateur"];

const MovieCard = ({ m, onPlay, onLike }) => {
  const { c } = useApp();
  const isLive = m.status === "live";
  return (
    <div style={{ background: c.card, borderRadius: 14, border: `1px solid ${c.border}`, overflow: "hidden", marginBottom: 10 }}>
      <div onClick={onPlay} style={{ position: "relative", cursor: "pointer", height: 160, background: m.thumbnail_url ? `url(${m.thumbnail_url}) center/cover` : "linear-gradient(135deg, #1a1a2e, #16213e)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {!m.thumbnail_url && <div style={{ fontSize: 40 }}>🎬</div>}
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(transparent 50%, rgba(0,0,0,0.7))", display: "flex", alignItems: "flex-end", padding: 12 }}>
          <div style={{ flex: 1 }}>
            {isLive && <span style={{ display: "inline-block", padding: "3px 8px", borderRadius: 6, background: "#ef4444", color: "#fff", fontSize: 10, fontWeight: 700, marginBottom: 4, animation: "pulse 2s infinite" }}>🔴 LIVE NOW</span>}
            <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>{m.title}</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", marginTop: 2 }}>{m.category} {m.duration_minutes ? `· ${m.duration_minutes} min` : ""}</div>
          </div>
          <div style={{ width: 44, height: 44, borderRadius: 22, background: "rgba(255,255,255,0.2)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>▶</div>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px" }}>
        <div style={{ display: "flex", gap: 14 }}>
          <button onClick={onLike} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 4, color: m.is_liked ? "#ef4444" : c.sub, fontSize: 12, fontWeight: 600 }}>
            {m.is_liked ? "❤️" : "🤍"} {m.like_count || 0}
          </button>
          <span style={{ display: "flex", alignItems: "center", gap: 4, color: c.sub, fontSize: 12 }}>👁 {m.view_count || 0}</span>
        </div>
        <span style={{ fontSize: 10, color: c.faint, textTransform: "uppercase", fontWeight: 600 }}>{m.status === "live" ? "Streaming" : "Replay"}</span>
      </div>
    </div>
  );
};

const toEmbedUrl = (url) => {
  if (!url) return url;
  // YouTube: convert watch/short URLs to embed
  let m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([\w-]+)/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;
  // Vimeo: convert to embed
  m = url.match(/vimeo\.com\/(\d+)/);
  if (m) return `https://player.vimeo.com/video/${m[1]}`;
  return url;
};

const MoviePlayer = ({ movie, onBack, onLike }) => {
  const { c } = useApp();
  if (!movie) return null;
  const videoUrl = toEmbedUrl(movie.video_url);
  const isEmbed = videoUrl?.includes("youtube.com/embed") || videoUrl?.includes("player.vimeo.com") || videoUrl?.includes("embed") || videoUrl?.includes("iframe");
  return (
    <Shell title="" showBack onBack={onBack} noPad>
      <div>
        {/* Video Player - YouTube style */}
        <div style={{ background: "#000", position: "relative" }}>
          {movie.status === "live" && <div style={{ position: "absolute", top: 10, left: 10, zIndex: 2, padding: "4px 10px", borderRadius: 6, background: "#ef4444", color: "#fff", fontSize: 10, fontWeight: 700 }}>🔴 LIVE</div>}
          {isEmbed ? (
            <iframe src={videoUrl} style={{ width: "100%", height: 240, border: "none", display: "block" }} allowFullScreen allow="autoplay; encrypted-media; fullscreen" title={movie.title} />
          ) : (
            <video src={videoUrl} controls autoPlay style={{ width: "100%", height: 240, display: "block", objectFit: "contain", background: "#000" }} controlsList="nodownload" playsInline />
          )}
        </div>
        <div style={{ padding: "0 16px" }}>
        <div style={{ background: c.card, borderRadius: 14, border: `1px solid ${c.border}`, padding: 16, marginBottom: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
            <div>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: c.text, margin: 0 }}>{movie.title}</h3>
              <div style={{ fontSize: 11, color: c.sub, marginTop: 3 }}>{movie.category} {movie.duration_minutes ? `· ${movie.duration_minutes} min` : ""} · {movie.view_count || 0} views</div>
            </div>
            <button onClick={onLike} style={{ display: "flex", alignItems: "center", gap: 5, padding: "8px 14px", borderRadius: 10, border: `1px solid ${movie.is_liked ? "#ef4444" : c.border}`, background: movie.is_liked ? "#ef444415" : c.card, color: movie.is_liked ? "#ef4444" : c.sub, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              {movie.is_liked ? "❤️" : "🤍"} {movie.like_count || 0}
            </button>
          </div>
          {movie.description && <p style={{ fontSize: 13, color: c.sub, margin: 0, lineHeight: 1.5 }}>{movie.description}</p>}
        </div>
        </div>
      </div>
    </Shell>
  );
};

export const MoviesPage = () => {
  const { c, go, user, flash } = useApp();
  const [movieData, setMovieData] = useState({ live: [], replays: [], categories: [], restricted: false, preview: [] });
  const [activeTab, setActiveTab] = useState("live");
  const [catFilter, setCatFilter] = useState("All");
  const [playing, setPlaying] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMovies = async () => {
    setLoading(true);
    const r = await api("/movies");
    if (r.ok) setMovieData(r.data);
    setLoading(false);
  };

  useEffect(() => { loadMovies(); }, []);

  const handlePlay = async (movie) => {
    const r = await api(`/movies/${movie.id}`);
    if (r.ok) setPlaying(r.data);
    else flash(r.data?.message || "Failed to load", "error");
  };

  const handleLike = async (movieId) => {
    const r = await api(`/movies/${movieId}/like`, { method: "POST" });
    if (r.ok) {
      if (playing && playing.id === movieId) {
        setPlaying(p => ({ ...p, is_liked: r.data.liked, like_count: r.data.like_count }));
      }
      setMovieData(prev => ({
        ...prev,
        live: prev.live.map(m => m.id === movieId ? { ...m, is_liked: r.data.liked, like_count: r.data.like_count } : m),
        replays: prev.replays.map(m => m.id === movieId ? { ...m, is_liked: r.data.liked, like_count: r.data.like_count } : m),
      }));
    }
  };

  if (playing) return <MoviePlayer movie={playing} onBack={() => setPlaying(null)} onLike={() => handleLike(playing.id)} />;

  // Restricted view for free users
  if (movieData.restricted) return (
    <Shell title="Movies" showBack onBack={() => go("feed")}>
      <div style={{ padding: "10px 0" }}>
        {/* Hero section */}
        <div style={{ borderRadius: 18, overflow: "hidden", marginBottom: 16, position: "relative" }}>
          <div style={{ height: 180, background: "linear-gradient(135deg, #1a1a2e, #2d1b4e, #1a1a2e)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
            <div style={{ position: "absolute", inset: 0, background: "radial-gradient(circle at 30% 50%, rgba(108,92,231,0.3), transparent 60%), radial-gradient(circle at 70% 50%, rgba(239,68,68,0.2), transparent 60%)" }} />
            <div style={{ textAlign: "center", position: "relative", zIndex: 1 }}>
              <svg width="50" height="50" viewBox="0 0 24 24" style={{ marginBottom: 10 }}><path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z" fill="#ef4444"/><path d="M10 9l5 3.5-5 3.5V9z" fill="white"/></svg>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#fff" }}>Exclusive Streaming</div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", marginTop: 4 }}>Premium & Elite Members Only</div>
            </div>
          </div>
        </div>

        {/* Preview cards - blurred but showing titles */}
        {movieData.preview?.length > 0 && movieData.preview.map(m => (
          <div key={m.id} style={{ background: c.card, borderRadius: 14, border: `1px solid ${c.border}`, overflow: "hidden", marginBottom: 10, position: "relative" }}>
            <div style={{ height: 120, background: m.thumbnail_url ? `url(${m.thumbnail_url}) center/cover` : "linear-gradient(135deg, #1a1a2e, #2d1b4e)", filter: "blur(12px)", transform: "scale(1.1)" }} />
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 120, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div style={{ width: 48, height: 48, borderRadius: 24, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg width="20" height="20" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" fill="rgba(255,255,255,0.8)"/></svg>
              </div>
            </div>
            <div style={{ padding: "12px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: c.text }}>{m.title}</div>
                <div style={{ fontSize: 10, color: c.faint, marginTop: 2 }}>{m.category} · {m.view_count || 0} views · {m.like_count || 0} likes</div>
              </div>
              {m.status === "live" && <span style={{ padding: "3px 8px", borderRadius: 6, background: "#ef4444", color: "#fff", fontSize: 9, fontWeight: 700 }}>LIVE</span>}
            </div>
          </div>
        ))}

        {/* What you get */}
        <div style={{ background: c.card, borderRadius: 16, border: `1px solid ${c.border}`, padding: 18, marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: c.text, marginBottom: 12 }}>What you unlock</div>
          {[
            { icon: "🔴", text: "Live streaming sessions", color: "#ef4444" },
            { icon: "▶️", text: "Full replay library", color: "#6c5ce7" },
            { icon: "🎭", text: "Multiple categories", color: "#f59e0b" },
            { icon: "❤️", text: "Like & interact with content", color: "#ec4899" },
          ].map((item, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 0", borderBottom: i < 3 ? `1px solid ${c.border}` : "none" }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: `${item.color}12`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{item.icon}</div>
              <span style={{ fontSize: 13, color: c.text, fontWeight: 600 }}>{item.text}</span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ background: "linear-gradient(135deg, #6c5ce7, #a23ad1)", borderRadius: 16, padding: "20px 18px", textAlign: "center" }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#fff", marginBottom: 6 }}>Ready to watch?</div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.75)", marginBottom: 14 }}>Starting from KES 499/month</div>
          <button onClick={() => go("premium")} style={{ width: "100%", padding: "13px 0", borderRadius: 12, border: "2px solid rgba(255,255,255,0.3)", background: "rgba(255,255,255,0.15)", backdropFilter: "blur(10px)", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Upgrade Now</button>
        </div>
      </div>
    </Shell>
  );

  const filteredReplays = catFilter === "All" ? movieData.replays : movieData.replays.filter(m => m.category === catFilter);

  const tabs = [
    { id: "live", label: "Live Now", icon: "🔴", count: movieData.live?.length || 0 },
    { id: "replays", label: "Replays", icon: "▶️", count: movieData.replays?.length || 0 },
  ];

  return (
    <Shell title="Movies" showBack onBack={() => go("feed")}>
      <div style={{ padding: "10px 0" }}>
        {/* Tabs */}
        <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
          {tabs.map(tb => (
            <button key={tb.id} onClick={() => setActiveTab(tb.id)}
              style={{ flex: 1, padding: "10px 0", borderRadius: 12, border: `1.5px solid ${activeTab === tb.id ? (tb.id === "live" ? "#ef4444" : c.pri) : c.border}`, background: activeTab === tb.id ? (tb.id === "live" ? "#ef444415" : c.priBg) : c.card, color: activeTab === tb.id ? (tb.id === "live" ? "#ef4444" : c.priTxt) : c.sub, fontSize: 12, fontWeight: 700, cursor: "pointer", textAlign: "center" }}>
              {tb.icon} {tb.label} ({tb.count})
            </button>
          ))}
        </div>

        {/* Live Now */}
        {activeTab === "live" && (
          movieData.live?.length > 0 ? movieData.live.map(m => (
            <MovieCard key={m.id} m={m} onPlay={() => handlePlay(m)} onLike={() => handleLike(m.id)} />
          )) : (
            <div style={{ textAlign: "center", padding: "40px 16px" }}>
              <div style={{ fontSize: 50, marginBottom: 10 }}>📡</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: c.text, marginBottom: 6 }}>No Live Streams Right Now</div>
              <div style={{ fontSize: 12, color: c.sub, lineHeight: 1.5 }}>Check back soon — live streams are announced in the community feed. Browse replays in the meantime!</div>
            </div>
          )
        )}

        {/* Replays */}
        {activeTab === "replays" && <>
          {/* Category filter */}
          <div style={{ display: "flex", gap: 5, marginBottom: 12, overflowX: "auto", paddingBottom: 4 }}>
            {["All", ...(movieData.categories || [])].map(cat => (
              <button key={cat} onClick={() => setCatFilter(cat)}
                style={{ padding: "5px 12px", borderRadius: 16, border: `1.5px solid ${catFilter === cat ? c.pri : c.border}`, background: catFilter === cat ? c.priBg : c.card, color: catFilter === cat ? c.priTxt : c.sub, fontSize: 11, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0 }}>{cat}</button>
            ))}
          </div>
          {filteredReplays.length > 0 ? filteredReplays.map(m => (
            <MovieCard key={m.id} m={m} onPlay={() => handlePlay(m)} onLike={() => handleLike(m.id)} />
          )) : <EmptyState icon="🎬" title="No replays yet" desc="Replays will appear here after live streams end" />}
        </>}
      </div>
    </Shell>
  );
};
